import React, { Component } from 'react';
import Links                from './containers/LinksContainer';
import AppStamp             from './AppStamp';
import './../css/Footer.css';

class Footer extends Component
{
    renderLogos = () =>
    {
        let { logos } = this.props;

        if (logos.length > 0)
        {
            let images = logos.map((logo, index) => {
                return <img alt="" key={ 'logo' + index } className="footer-logo" src={ logo } />
            });

            return (
                <div className="stamp">
                    { images }
                </div>
            );
        }
        else
        {
            return <AppStamp
                link="https://www.placesandtrails.com"
                title="Places and Trails"
                color={ this.props.theme.text }
            />
        }
    };

    render = () =>
    {
        return (
            <div id="footer">
                <div className="footer-one">
                    <Links />
                    { this.renderLogos() }
                </div>
                <div className="footer-two">
                    <p className="fs-10">Powered by&nbsp;
                        <a target="_blank" rel="noopener noreferrer" href="https://www.placesandtrails.com" title="Places and Trails">
                            Places & Trails
                        </a>
                        &nbsp;from&nbsp;
                        <a target="_blank" rel="noopener noreferrer" href="http://www.audiotrails.co.uk" title="Audio Trails">Audio Trails</a>
                    </p>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js